const validate = {
  rules: {
    tipo_rede_social_id: {
      required: true,
    },
    endereco: {
      required: true,
      url: true,
    },
  },
  messages: {
    tipo_rede_social_id: "O setor é obrigatório.",
    endereco: {
      required: "O endereço é obrigatório.",
      url: "O endereço é inválido",
    },
  },
};

export default validate;
